export default "__VITE_ASSET__0a3fd9e0__"